// extracted by mini-css-extract-plugin
export default {"aboutMeFoto":"AboutMe_aboutMeFoto__ZRY6o","subTitle":"AboutMe_subTitle__oVhiV","paragraph":"AboutMe_paragraph__fAiJ-"};